import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'
import TextButton from 'LuxKit/Button/TextButton'
import { mediaQueryUp } from 'components/utils/breakpoint'

export const PRICE_FOOTER_INSET = rem(10)
export const PRICE_BUTTON_GUTTER = rem(132)
export const PRICE_BUTTON_GUTTER_TABLET = rem(140)

const LesaViewOfferButton = styled(TextButton)`
  white-space: nowrap;
`

export const PriceDetailsContainer = styled.div<{ $compact?: boolean }>`
  position: relative;
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  height: ${props => rem(props.$compact ? 78 : 88)};

  ${mediaQueryUp.tablet} {
    height: ${props => rem(props.$compact ? 84 : 96)};
  }

  ${mediaQueryUp.desktop} {
    height: ${props => rem(props.$compact ? 78 : 88)};
  }
`

export const PriceDetailsContent = styled.div<{ $compact?: boolean }>`
  position: absolute;
  inset-inline-start: 0;
  inset-inline-end: 0;
  bottom: ${props => props.$compact ? rem(6) : PRICE_FOOTER_INSET};
  min-width: 0;
  padding-inline-end: ${props => props.$compact ? rem(100) : PRICE_BUTTON_GUTTER};

  ${mediaQueryUp.tablet} {
    padding-inline-end: ${props => props.$compact ? rem(108) : PRICE_BUTTON_GUTTER_TABLET};
  }
`

export const PriceContentInner = styled.div<{ $compact?: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  min-width: 0;

  ${props => props.$compact && `
    transform: scale(0.9);
    transform-origin: left bottom;
    width: calc(100% / 0.9);
  `}

  [dir="rtl"] & {
    ${props => props.$compact && `
      transform-origin: right bottom;
    `}
  }
`

export const PriceDetailsButton = styled.div<{ $compact?: boolean }>`
  position: absolute;
  inset-inline-end: 0;
  bottom: ${props => props.$compact ? rem(6) : PRICE_FOOTER_INSET};
`

export function ViewOfferButton({ compact = false }: { compact?: boolean }) {
  return (
    <LesaViewOfferButton kind="secondary" size={compact ? 'small' : 'medium'} nonInteractable>
      <FormattedMessage
        id="5Z2UK01V7Un76m4bIMWh"
        defaultMessage="View offer"
        description="CTA button label for LESA natural language search offer carousel cards"
      />
    </LesaViewOfferButton>
  )
}
